import { MapAsync } from "../async/MapAsync"
import { AtomToUint8 } from "../bytes/AtomToUint8"
import type { AsyncSequence } from "../types/AsyncSequence"
import type { Atom } from "../types/Atom"
import type { GUID } from "../types/GUID"
import { UInt8Hash } from "./UInt8Hash"

export async function AtomHash(stream: AsyncSequence<Atom>): Promise<GUID> {
  return UInt8Hash(MapAsync(AtomToUint8, stream))
}
